import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import ContentTemplateForm from './ContentTemplateForm';
import FormToolbar from '../shared/FormToolbar';

const ContentTemplateEdit = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ContentTemplateForm {...props} />
    </SimpleForm>
  </Create>
);

export default ContentTemplateEdit;
